// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"d86f0f90","197":"ae23dc7e","212":"af2f473f","396":"07423149","421":"25b1d5ea","655":"1916de01"}[chunkId] + ".chunk.css";
};